export default "__VITE_ASSET__DzTOUsFk__"